module.exports = __webpack_public_path__ + "img/quotes.5828a533.svg";